<script setup lang="ts">
import { useGameState } from '@/stores/gameState'
import { storeToRefs } from 'pinia'
import { ref, watch } from 'vue'

const props = defineProps<{ reverseDeltaPosition?: boolean }>()

const DELTA_SHOW_TIME = 2000

const { score, delta } = storeToRefs(useGameState())
const deltaVisible = ref(false)

watch(
  () => delta.value,
  () => {
    deltaVisible.value = true
    setTimeout(() => {
      deltaVisible.value = false
    }, DELTA_SHOW_TIME)
  }
)
</script>

<template>
  <div
    :class="{
      'h-[34px] flex items-center gap-1 bg-background py-2 rounded': true,
      'flex-row-reverse': props.reverseDeltaPosition
    }"
  >
    <div class="h-[34px] flex items-center gap-1">
      <div class="text-[12px] leading-[10px] font-normal text-secondary">
        {{ $t('label.Score') }}
      </div>
      <div class="text-[14px] leading-[15px] font-semibold text-white">{{ score }}</div>
    </div>
    <transition name="score-delta-slide-up">
      <div
        v-if="deltaVisible && delta"
        class="text-white bg-rank-delta text-[11px] font-semibold h-[18px] px-2 rounded-[20px] flex items-center"
      >
        {{ delta > 0 ? `+${delta}` : delta }}
      </div>
    </transition>
  </div>
</template>

<style lang="scss">
.score-delta-slide-up {
  &-enter-active,
  &-leave-active {
    transition: all 0.5s ease;
  }

  &-enter-from,
  &-leave-to {
    transform: translateY(-15px);
    opacity: 0;
  }
}
</style>
